import type { I_QandA } from '../interfaces'
import { ListNames } from '../config/configuration'
import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { loadBlobFilesForItem } from './detailview'

export type QnaInnerViewItem = I_QandA & {
  AttachmentFiles?: Array<{ FileName: string; ServerRelativeUrl: string }>
}

const normalizeQnaItem = (item: any): QnaInnerViewItem => ({
  ...item,
  Title: item.Question ?? item.Title ?? '',
  AttachmentFiles: item.AttachmentFiles ?? [],
  Tags: item.Tags ?? '',
  ItemModifiedBy: item.ItemModifiedBy ?? { Title: 'System' }
})

export const getQnaData = async (): Promise<QnaInnerViewItem[]> => {
  try {
    const list = await rhybusRListsHttp().getList(ListNames.QANDA)
    const items = [...(await list.query().orderBy([{ orderBy: 'ItemModified', ascending: false }]).get<I_QandA>())]
    const activeItems = (items ?? []).filter((item: I_QandA) => !item.IsDeleted && item.IsArchived === false)
    const mapped = activeItems.map((item) => normalizeQnaItem(item as any))
    await Promise.all(mapped.map(async (item: any) => {
      if (!item.eKey) return
      const files = await loadBlobFilesForItem(item.eKey, 'qanda', 'qanda')
      if (files.length > 0) item.AttachmentFiles = files
    }))
    return mapped
  } catch (error) {
    console.error('Failed to fetch Q&A data:', error)
    return []
  }
}

export const qnaItems = await getQnaData()
